import _get from 'lodash/get'

import { generateGetFlowValueFunctions } from '@flows/insurance/utils'

import { FAILURE_REASONS } from './constants'
import type { GetFailureReason } from './types'

const getLiabilityAnalyticsFailureReason: GetFailureReason = ({
  formValues,
  stepTransformer = (step: string) => step,
  currentStep,
}) => {
  const { getParamPath } = generateGetFlowValueFunctions('liability_v1_getsafe_de')

  switch (currentStep) {
    case stepTransformer('liability_cancelled'): {
      const previousInsuranceCancelledByInsurer = _get(
        formValues,
        getParamPath('cancelled_by_previous_insurer')
      )
      return {
        reason: FAILURE_REASONS.PREVIOUS_INSURANCE_VOIDED,
        extraData: { previousInsuranceCancelledByInsurer },
      }
    }
    case stepTransformer('liability_damages'): {
      const selectedNumberOfPreviousClaims = _get(
        formValues,
        getParamPath('number_of_claims_in_last_5y')
      )
      return {
        reason: FAILURE_REASONS.TOO_MANY_PREVIOUS_CLAIMS,
        extraData: { selectedNumberOfPreviousClaims },
      }
    }
    default: {
      break
    }
  }
}
export default getLiabilityAnalyticsFailureReason
